import type { InfoBoxProps } from '../../../../../shared/types/toolTypes'

export const triageData = {
  buttons: [
    {
      label: 'Legal service',
      id: 'legal',
    },
    {
      label: 'Money Helpline',
      id: 'money',
    },
    {
      label: 'Tech Support',
      id: 'tech',
    },
  ],
  title:
    'Before we check if we can help you with your issue, could you specify what you need help with',
  imgObj: {
    src: 'https://media.product.which.co.uk/prod/images/original/gm-c13ec987-324f-4da1-93da-64d64e6a743a-holiday-complaint-6.jpg',
    alt: 'Two people stressed around a desk',
  },
  infoBox: {
    heading: 'Please note:',
    borderColour: 'blue',
  } as InfoBoxProps,
  infoBoxParagraphs: [
    {
      text: 'Only named account holders are able to book appointments via our online system. Family members who live at the same address are entitled to use the service but must call to book an appointment on <a class="sb-link-primary" href="tel:+02922670000"><span class="sb-link-animation-wrapper">02922 670000</span></a>. Appointments booked online for anyone other than the named account holder will be cancelled.',
    },
  ],
}
